<template>
<div>
  <vue-element-loading :active="isActive" spinner="ring" color="#428BCA"></vue-element-loading>
  <div v-if="layout">
    <label class="col-sm-3 control-label no-padding-right" :for="name"> {{ name }}</label>
    <div class="col-sm-5">
      <select class="form-control" ref="Select" :value="value" @input="updateSelect" :required="required">
        <option :value="null">{{ optionText ? optionText : 'Selecione'}}</option>
        <option :value="d[id]" v-for="(d, k) in dados" :key="k" :selected="d[id] == value">{{ d[titulo] }}</option>
      </select>
    </div>
  </div>
  <div v-else>
    <label :for="name">{{ name }}</label>
    <select class="form-control" ref="Select" :value="value" @input="updateSelect" :required="required">
      <option :value="null">{{ optionText ? optionText : 'Selecione'}}</option>
      <option :value="d[id]" v-for="(d, k) in dados" :key="k" :selected="d[id] == value">{{ d[titulo] }}</option>
    </select>
  </div>
</div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import req from '@/components/request'

export default {
  components: {
    VueElementLoading
  },
  props: ['value', 'name', 'url', 'params', 'id', 'titulo', 'layout', 'optionText', 'required', 'session'],
  data () {
    return {
      dados: [],
      isActive: false
    }
  },

  methods: {
    updateSelect () {
      this.$emit('input', this.$refs.Select.value)
    },
    getRequest () {
        if (sessionStorage.getItem(`_${this.url}`) && !this.session) {
        this.dados = JSON.parse(sessionStorage.getItem(`_${this.url}`))
      } else {
        this.isActive = true
        req(this.url, 'get', this.params).then(resp => {
          this.dados = resp
          sessionStorage.setItem(`_${this.url}`, JSON.stringify(resp))
          this.isActive = false
        })
      }
    }
  },
  mounted () {
    this.getRequest()
  }
}
</script>

<style lang="stylus" scoped>

</style>
